import type { FC } from 'react';

import type { EntityType } from '@core/types/search';

import { SlabTabs } from '../SlabTabs/SlabTabs';
import { ENTITY_CONFIGS } from './entityConfig';
import type { EntitySearchTab } from './useEntitySearch';

type Props = {
  entityTypes: EntityType[];
  activeTab: EntitySearchTab;
  onChange: (tab: EntitySearchTab) => void;
  getCount: (type: EntityType) => number;
  totalCount: number;
};

export const EntitySearchTabs: FC<Props> = ({
  entityTypes,
  activeTab,
  onChange,
  getCount,
  totalCount,
}) => (
  <SlabTabs<EntitySearchTab>
    value={activeTab}
    onChange={onChange}
    items={[
      { value: 'all', label: 'All', count: totalCount },
      ...entityTypes.map((type) => ({
        value: type,
        label: ENTITY_CONFIGS[type].pluralLabel,
        count: getCount(type),
      })),
    ]}
  />
);
